import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LikeService } from '@app/shared/services/like/like.service';
import { IsLoggedGuard } from '@app/shared/guards';
import { LikeTypes } from '@app/shared/components/like/like-types.enum';

@Component({
  selector: 'vc-like',
  templateUrl: './like.component.html',
  styleUrls: ['./like.component.scss']
})
export class LikeComponent implements OnInit {
  @Input()
  isLiked: boolean;

  @Input()
  likeCount: number;

  @Input()
  idItem: string;

  @Input()
  type: string;

  @Input()
  className: string;

  @Input()
  isOldDesign = false;

  @Output()
  likeSuccess: EventEmitter<Boolean> = new EventEmitter();

  isCatalogLike = false;
  isProductLike = false;
  isCommentLike = false;
  isBrandLike = false;

  constructor(private likeService: LikeService, private loggedGuard: IsLoggedGuard) {}

  ngOnInit() {
    if (this.type === LikeTypes.PRODUCTS) {
      if (this.className === 'productPage__like') {
        this.isProductLike = true;
        this.isCatalogLike = false;
      } else {
        this.isCatalogLike = true;
      }
    }
    if (this.type === LikeTypes.BRANDS) {
      this.isProductLike = true;
    }
    if (this.type === LikeTypes.COMMENTS) {
      this.isCommentLike = true;
    }
  }

  likeItems() {
    if (this.loggedGuard.isLoggedIn()) {
      this.like();
    }
  }

  like() {
    if (this.isLiked) {
      this.likeService.unLike(this.type, this.idItem).subscribe(
        _ => {
          this.isLiked = false;
          if (this.likeCount > 0) {
            this.likeCount--;
          }
          this.likeSuccess.emit(false);
        },
        error => {
          console.log('Error like function in LikeComponent unLike function failed  :', error);
        }
      );
    } else {
      this.likeService.like(this.type, this.idItem).subscribe(
        _ => {
          this.isLiked = true;
          this.likeCount++;
          this.likeSuccess.emit(true);
        },
        error => {
          console.log('Error like function in LikeComponent like function failed  :', error);
        }
      );
    }
  }
}
